export default __webpack_public_path__ + "static/media/question-primary.479ad551.svg";